import React, {memo, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../styles/commonStyles';
import {BooleanInputProps} from './booleanInputTypes';
import {BooleanInputWithLabel} from './booleanInputWithLabel';

/*
 * Props.
 */

export type RadioButtonProps = Omit<BooleanInputProps, 'size'> & {
  className?: string;
};

/*
 * Style.
 */

const StyledRadioDiv = styled.div`
  // This width and height is not for the overall radio button, but rather for
  // the small circle in the middle that does not change color when the button
  // is selected
  width: 6px;
  height: 6px;

  border-radius: 50%;
  background-color: currentColor;
`;

/*
 * Component.
 */

/** Radio button controlled input. */
export const RadioButton = memo<PropsWithChildren<RadioButtonProps>>((props) => {
  const {onChange, className, isChecked, isDisabled, children} = props;
  return (
    <BooleanInputWithLabel
      className={className}
      onChange={onChange}
      isChecked={isChecked}
      isDisabled={isDisabled}
      type="radio"
      checkedIndicator={<StyledRadioDiv />}
      size={VisualSizesEnum.MEDIUM}
      useCircularIndicator
    >
      {children}
    </BooleanInputWithLabel>
  );
});
